import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { User } from '../model/user';
import { getStoredUser } from '../helpers/user-storage.util';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    ReactiveFormsModule,
  ],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
})
export class ContactUsComponent {
  emailRegx: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  invalidEmail: boolean = false;
  isSubmitting = false;

  contactUsForm = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(this.emailRegx),
    ]),
    phone: new FormControl(''),
    organizationName: new FormControl(''),
    message: new FormControl('', [Validators.required]),
  });

  user: User = {};

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private toastr: ToastrService,
    private userService: UserService
  ) {
    this.matIconRegistry.addSvgIcon(
      'twitter',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/x.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'linkedin',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/linkedin.svg'
      )
    );
  }

  ngOnInit() {
    this.user = getStoredUser();
    if (this.user) {
      this.contactUsForm.patchValue({
        firstName: this.user.firstName ?? '',
        lastName: this.user.lastName ?? '',
        email: this.user.email ?? '',
        phone: this.user.phone ?? '',
        organizationName: this.user.organization?.name,
      });
    }
  }

  sendEmail() {
    if (this.contactUsForm.invalid) {
      this.contactUsForm.markAllAsTouched();
      if (
        this.contactUsForm.value.email != '' &&
        this.contactUsForm.value.email?.match(this.emailRegx) == null
      ) {
        this.invalidEmail = true;
      }
    } else if (this.contactUsForm.valid) {
      this.isSubmitting = true;
      this.userService
        .sendContactUsEmail({
          firstName: this.contactUsForm.value.firstName,
          lastName: this.contactUsForm.value.lastName,
          email: this.contactUsForm.value.email,
          phone: this.contactUsForm.value.phone,
          organizationName: this.contactUsForm.value.organizationName,
          message: this.contactUsForm.value.message,
        })
        .subscribe({
          next: (response: any) => {
            this.isSubmitting = false;
            const apiResponse = response;
            if (apiResponse.status === 'FAILURE') {
              if (apiResponse.message) {
                this.toastr.error(apiResponse.message);
              } else {
                this.toastr.error('An error occurred. Please try again.');
              }
            } else {
              if (apiResponse.message) {
                this.toastr.success(apiResponse.message);
              } else {
                this.toastr.success(
                  'Thank you for reaching out to us! We have received your message and our team is currently reviewing it.'
                );
              }
            }
            // reseting the message field, but want to keep what user previously entered
            this.contactUsForm.reset({
              firstName: this.contactUsForm.value.firstName,
              lastName: this.contactUsForm.value.lastName,
              email: this.contactUsForm.value.email,
              phone: this.contactUsForm.value.phone,
              organizationName: this.contactUsForm.value.organizationName,
            });
          },
          error: () => {
            this.isSubmitting = false;
            this.toastr.error('An error occurred. Please try again.');
          }
        });
    }
  }

  clearEmailValidation() {
    this.invalidEmail = false;
  }
}
